import { useMemo } from 'react'

import { useScreen } from '@/store/screen'

export const useServiceDetail = () => {
  const { windowSize } = useScreen()

  const fontSizesByScreenSize = useMemo(() => {
    const fontsSizesByScreen = {
      1440: {
        titleDetail: 'h4' as const,
        subtitleDetail: 'b2' as const,
        descriptionDetail: 'b3' as const,
      },
      791: {
        titleDetail: 'b1' as const,
        subtitleDetail: 'b3' as const,
        descriptionDetail: 'b3' as const,
      },
    }

    return fontsSizesByScreen
  }, [])

  const { width } = windowSize
  const fontSizes = useMemo(() => {
    if (!width) return fontSizesByScreenSize[1440]
    if (width <= 791) return fontSizesByScreenSize[791]

    return fontSizesByScreenSize[1440]
  }, [width, fontSizesByScreenSize])

  return {
    fontSizes,
  }
}
